function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import { Page } from "@sprout/client-layout";
import { ItemMemberLevel, TopicPage_Views_Core_ItemOrDirectChildUpdatedDocument } from "sprout-graphql";
import FeatureFlaggedSubscription from "@sprout/client-lib/dist/FeatureFlaggedSubscription";
import { useSetGoBackURL } from "@sprout/providers/dist/goBack";
import useGoUp from "@sprout/hooks/dist/useGoUp";
import TopicPageAppBar from "./TopicPage_AppBar";
import { TopicPageProvider } from "./TopicPageContext";
import TopicPageNavigationBreadcrumbs from "./TopicPage_NavigationBreadcrumbs";
import useTopicPageShortcuts from "./useTopicPageShortcuts";
import TopicPagePageBanner from "./TopicPage_Page_Banner";
const TopicPagePage = (props)=>{
    const { topic , main , appBar , goBackURL: goBackURLProp , onDrop  } = props;
    const { rootTopicOrSelf , deletedAt , archivedAt , id  } = topic;
    const { owner  } = rootTopicOrSelf || {};
    const role = useMemo(()=>{
        if (rootTopicOrSelf) {
            const { memberLevel  } = rootTopicOrSelf;
            return {
                isOwner: memberLevel === ItemMemberLevel.Owner,
                isOwnerOrAdmin: memberLevel ? [
                    ItemMemberLevel.Owner,
                    ItemMemberLevel.Admin
                ].includes(memberLevel) : false,
                isPartOfTopic: memberLevel ? ![
                    ItemMemberLevel.Invited,
                    ItemMemberLevel.Pending
                ].includes(memberLevel) : false
            };
        } else return {
            isOwner: false,
            isOwnerOrAdmin: false,
            isPartOfTopic: false
        };
    }, [
        rootTopicOrSelf
    ]);
    const contextValue = useMemo(()=>{
        return _objectSpread({}, role, {
            disabled: deletedAt !== null || archivedAt !== null
        });
    }, [
        archivedAt,
        deletedAt,
        role
    ]);
    useTopicPageShortcuts({
        owner,
        topic: rootTopicOrSelf
    });
    const ownerUsername = (owner === null || owner === void 0 ? void 0 : owner.username) || "";
    const goBackURL = useMemo(()=>{
        if (goBackURLProp) return goBackURLProp;
        if (role.isPartOfTopic) return "/trees";
        return `/${ownerUsername}`;
    }, [
        goBackURLProp,
        ownerUsername,
        role.isPartOfTopic
    ]);
    useSetGoBackURL(goBackURL);
    useGoUp(goBackURL);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            rootTopicOrSelf && /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(FeatureFlaggedSubscription, {
                    subscription: TopicPage_Views_Core_ItemOrDirectChildUpdatedDocument,
                    variables: {
                        topicId: id
                    }
                })
            }),
            /*#__PURE__*/ _jsx(TopicPageProvider, {
                value: contextValue,
                children: /*#__PURE__*/ _jsxs(Page, {
                    onDrop: onDrop,
                    variant: "shadow",
                    banner: /*#__PURE__*/ _jsx(TopicPagePageBanner, {
                        topic: topic
                    }),
                    // aside={<Sidebar item={topic} />}
                    appBar: /*#__PURE__*/ _jsx(TopicPageAppBar, {
                        content: appBar
                    }),
                    children: [
                        /*#__PURE__*/ _jsx(TopicPageNavigationBreadcrumbs, {
                            topic: topic
                        }),
                        main
                    ]
                })
            })
        ]
    });
};
export default TopicPagePage;
